/* KeukenGadgets — alleen wat echt JavaScript nodig heeft.
   Titels en uitklapblokken worden server-side (Liquid) opgebouwd. */
(function () {
  // Verwachte bezorgdatum: vandaag + min..max werkdagen (hangt af van de datum van de bezoeker)
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) days--;
    }
    return d;
  }

  function renderEta() {
    var fmt = new Intl.DateTimeFormat('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
    document.querySelectorAll('[data-kg-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (!min || !max) return;
      var now = new Date();
      var out = el.querySelector('[data-kg-eta-range]');
      if (out) out.textContent = fmt.format(addBusinessDays(now, min)) + ' en ' + fmt.format(addBusinessDays(now, max));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderEta);
  else renderEta();
})();

(function () {
  // v9: "Maak het af met" in de winkelwagen (snippets/kg-cart-upsell.liquid).
  // In de lade: toevoegen en de lade opnieuw opbouwen. Op /cart: pagina herladen.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kg-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled) return;

    var drawer = btn.closest('cart-drawer');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Bezig…';

    var item = btn.closest('.kg-upsell__item');
    var select = item && item.querySelector('[data-kg-variant]');
    var variantId = select ? select.value : btn.getAttribute('data-kg-add');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: data.items && data.items[0] && data.items[0].product_id, sections: data.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Niet gelukt';
        setTimeout(function () { btn.textContent = label; }, 2500);
      });
  });
})();
